import { baseFetch } from 'src/utils';

/**
 *
 * @param cartId - the id of the cart to approve
 * @param layer - the layer of the cart the current user is acting on
 * @param emailOriginalRequester - this will be true if multi-layer approvals is disabled or if the current user is not requesting an additional layer of approval
 * @returns
 */
export const approveCartAPI = async (
  cartId: string,
  layer: number,
  emailOriginalRequester: boolean,
) => {
  const body = { layer, emailOriginalRequester };

  const res = await baseFetch(`/api/org/cart-approvals/${cartId}/approve`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new Error('Failed to approve cart');
  }

  return true;
};
